<template>
  <div :class="$style['number-page']">
    <NumberPageMobile v-if="isMobile" />
    <NumberPageWeb v-else />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import NumberPageMobile from './NumberPageMobile.vue'
import NumberPageWeb from './NumberPageWeb.vue'
export default {
  name: '',
  components: {
    NumberPageMobile,
    NumberPageWeb
  },
  props: {
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState(['isMobile'])
  },
  created () {
  },
  mounted () {
  },
  watch: {
  },
  methods: {}
}
</script>
<style lang='scss' module>
.number-page {

}
</style>
